import { useStoreRoot } from '~/stores/abstract/root';
import { useStoreCountry } from '~/stores/client/country';
import { useStoreSsPlayer } from '~/stores/softswiss/player';
import { useStoreTransactionHistory } from '~/stores/softswiss/transactionHistory';

export default defineNuxtPlugin(() => {
  const router = useRouter();

  if (!router) {
    return;
  }
  let isCountryChecked = false;
  router.afterEach(async (_to, _from) => {
    if (!import.meta.browser) {
      return;
    }

    const storeSsPlayer = useStoreSsPlayer();
    const storeCountry = useStoreCountry();
    const storeRoot = useStoreRoot();
    const storeTransactionHistory = useStoreTransactionHistory();
    if (!storeCountry.country || !isCountryChecked) {
      await storeCountry.check();
      isCountryChecked = true;
    }

    let userType = 'new';

    if (storeSsPlayer.isPlayerAuthorised) {
      await storeTransactionHistory.loadPayments();
      const deposits = storeTransactionHistory.payments.filter((item) => item.action === 'deposit');
      if (!deposits.length) {
        userType = 'registered';
      } else if (deposits.length === 1) {
        userType = 'first_deposit';
      } else {
        userType = 'returned';
      }
    }

    useGtm()?.push({
      user_id: storeSsPlayer.playerId,
      language: storeRoot.userLang,
      user_type: userType,
      currency: storeRoot.userCurrency,
    });
  });
});
